import React from "react";
const SkeletonLoader = () => (
  <div
    className={` pt-3.5 lg:!mx-40 bg-white  h-[272px] lg:rounded-xl lg:shadow-custom lg:border`}
  >
    <div className="flex justify-between items-center flex-wrap px-6  mb-4  pb-4 md:pb-0  border-b  sm:border-none  ">
      <div className=" flex  flex-col gap-[4px] animate-pulse">
        <div className="text-xl w-[208px] rounded h-[40px]  bg-greyShade !font-geomanistBold leading-[44px] text-blackShade"></div>
        <div className="text-greyish  w-[208px] rounded h-[20px]  bg-greyShade leading-[28px] font-normal "></div>
        <div className="text-greyish  w-[208px] rounded h-[20px]  bg-greyShade leading-[28px]  font-normal"></div>
      </div>

      <div
        className={` flex  animate-pulse  flex-wrap gap-2  mt-4 md:mt-0  w-full md:w-auto `}
      >
        <div className="w-[130px] h-[40px] rounded bg-greyShade "></div>
        <div className="w-[130px] h-[40px] rounded bg-greyShade "></div>
      </div>
    </div>
    <div className=" animate-pulse bg-greyShade hidden md:flex w-[230px] h-[30px]   mx-6 text-blackShade mb-4"></div>
    <div className="bg-greyShade animate-pulse  h-[75px] rounded   mx-6  mb-4"></div>
  </div>
);

const SkeletonBox = () => (
  <div
    className={` bg-white shadow-custom  py-[26px] rounded-lg  lg:shadow-minShadow  w-full   `}
  >
    <div className="bg-greyShade mx-5  w-[176px] h-[20px] animate-pulse   mb-6"></div>
    {[...Array(5)].map((_, index) => (
      <div key={index} className="space-y-2 mx-5  ">
        <div className="flex md:px-6 py-4 border-b border-gray-200 last:border-b-0">
          <div className="w-10 animate-pulse h-10 bg-gray-100 rounded-full flex items-center justify-center mr-4"></div>
          <div className="flex-grow overflow-hidden">
            <div className="flex justify-between items-start">
              <div className="flex  animate-pulse flex-col  gap-y-1 md:gap-y-3.5">
                <p className=" bg-greyShade md:mx-5 w-[110px] md:w-[176px] h-[20px] "></p>
                <p className="bg-greyShade md:mx-5 w-[110px] md:w-[176px] h-[20px] "></p>
              </div>
              <div className="flex  animate-pulse flex-col  gap-y-1 md:gap-y-3.5">
                <p className="bg-greyShade md:mx-5 w-[110px] md:w-[176px] h-[20px]"></p>
                <p className="bg-greyShade md:mx-5 w-[110px] md:w-[176px] h-[20px]"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

const SkeletonQuickActions = () => (
  <div className="mt-6 lg:mt-0 mx-6  bg-white lg:mx-0">
    <div className="text-xl h-[20px] w-[123px] rounded animate-pulse    bg-greyShade shadow-custom mb-6"></div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-[23px] 2xl:gap-11 xl:grid-cols-4">
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="flex shadow-custom h-[116px] flex-col p-[10px] py-[12px] space-y-[14px] rounded-lg"
        >
          <div
            className={`flex  flex-col p-[10px]  py-[12px] space-y-[14px] rounded-lg `}
          >
            <div className="flex justify-between items-start ">
              <div className="  animate-pulse   w-[120px] h-[20px]  bg-greyShade"></div>
            </div>
            <div className="flex justify-between items-center">
              <div className={` max-h-[60px]   `}>
                <div
                  className="  animate-pulse  w-[180px] h-[20px]  bg-greyShade md:mb-1 
         "
                ></div>
                <div
                  className="   animate-pulse  w-[180px] h-[20px]  bg-greyShade md:mb-1 
         "
                ></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
const SkeletonFAQSupport = () => (
  <div className="mx-6 mb-[72px] lg:!mx-40 bg-white shadow-custom   p-4 md:px-7  rounded-lg flex justify-between items-center ">
    <div>
      <div className="w-[220px] h-[25px] bg-greyShade animate-pulse  mb-[6px] lg:mb-2"></div>
      <div className=" mb-[17px]  w-[160px] h-[25px] bg-greyShade animate-pulse  "></div>
      <div className=" flex space-x-4">
        <div className=" w-[120px] h-[30px] bg-greyShade animate-pulse"></div>
        <div className=" w-[120px] h-[30px] bg-greyShade animate-pulse"></div>
      </div>
    </div>
    <div className="hidden md:block">
      <div className=" rounded-md w-[167px] h-[154px] bg-greyShade animate-pulse" />
    </div>
  </div>
);

// Debit Card Skeleton
const SkeletonDebitCard = () => (
  <div className="w-full lg:px-40 CardBackground my-10">
    <div className="flex flex-col rounded-lg p-[22px] bg-debit-card-bg shadow-debit-card gap-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="w-[180px] h-[22px] bg-greyShade animate-pulse rounded"></div>
        <div className="w-[140px] h-[40px] bg-greyShade animate-pulse rounded-[8px]"></div>
      </div>

      {/* Card and Grid Section */}
      <div className="flex flex-col lg:flex-row gap-6 lg:items-center">
        {/* Card Skeleton - 40% */}
        <div className="w-full lg:w-[40%]">
          <div className="w-full rounded-2xl overflow-hidden bg-greyShade animate-pulse p-6 space-y-4 min-h-[240px]">
            {/* Card Header */}
            <div className="flex justify-between items-start">
              <div className="w-10 h-10 bg-gray-300 animate-pulse rounded"></div>
              <div className="w-12 h-7 bg-gray-300 animate-pulse rounded-full"></div>
            </div>

            {/* Card Number */}
            <div className="w-full h-6 bg-gray-300 animate-pulse rounded mt-8"></div>

            {/* CVV and Expiry */}
            <div className="flex justify-between mt-6">
              <div className="space-y-2">
                <div className="w-12 h-3 bg-gray-300 animate-pulse rounded"></div>
                <div className="w-16 h-4 bg-gray-300 animate-pulse rounded"></div>
              </div>
              <div className="space-y-2">
                <div className="w-12 h-3 bg-gray-300 animate-pulse rounded"></div>
                <div className="w-16 h-4 bg-gray-300 animate-pulse rounded"></div>
              </div>
            </div>

            {/* Card Footer */}
            <div className="flex justify-between items-center mt-4 pt-4">
              <div className="w-24 h-5 bg-gray-300 animate-pulse rounded"></div>
              <div className="w-12 h-6 bg-gray-300 animate-pulse rounded"></div>
            </div>
          </div>
        </div>

        {/* Feature Grid Skeleton - 60% */}
        <div className="w-full lg:w-[60%]">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
            {[1, 2, 3, 4].map((index) => (
              <div
                key={index}
                className="flex bg-white flex-col items-start gap-3 p-4 rounded-[10px] min-h-[131px]"
              >
                <div className="w-8 h-8 bg-greyShade animate-pulse rounded"></div>
                <div className="space-y-2 w-full">
                  <div className="w-3/4 h-4 bg-greyShade animate-pulse rounded"></div>
                  <div className="w-2/3 h-4 bg-greyShade animate-pulse rounded"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Learn More Button Skeleton */}
      <div className="flex justify-end">
        <div className="w-[111px] h-[40px] bg-greyShade animate-pulse rounded-[8px]"></div>
      </div>
    </div>
  </div>
);

export {
  SkeletonLoader,
  SkeletonBox,
  SkeletonQuickActions,
  SkeletonFAQSupport,
  SkeletonDebitCard,
};
